import type { ChatProfile } from '@customTypes/chat';
import type { RequestConfig } from '@customTypes/index';
import type { Role } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type GetChatProfiles = {
  profileType: Role;
  profileId: string;
};

export type GetChatProfilesParams = RequestConfig<GetChatProfiles>;

export const getChatProfile = async ({
  params,
  config
}: GetChatProfilesParams) =>
  api.get<ChatProfile>('/api/chat/my-chat-profile', {
    ...config,
    params
  });
